// Module
var code = `<div class="login_screen {{^.visible}}hidden {{/}}">
    <div class="space_img" style='background: url({{.splashImgSrc}}) no-repeat center center transparent;'></div>
    <div class="login_control">
        <div class="{{.logo_login_style}}" style='background: url({{.loginLogoSrc}}) no-repeat center center transparent;'></div>
        <div class="edit_section">
            <investingComboBox styleClassed="investing_comboBox_login" 
                enabled="{{.loginEnabled}}" 
                selectedItem="{{.selectedConnectionInfoMenuItem}}"
                items="{{.connectionInfoMenuItems}}" 
                visible="{{.connectionInfoMenuItems.length > 1 && inputMode}}"/>
            <investingTextBox name="tbLogin" styleClassed="investing_input_container_login" placeholder="Login"
                              text="{{.connectionParams.login}}" enabled="{{.loginEnabled}}" autofocus="true" />

            <investingPasswordTextBox visible="{{inputMode}}"
                name="tbPwd"
                showPasswordPreview="{{.selectedConnectionInfoMenuItem.value.allowPasswordPreview && !.savePasswordCheckedFromConnectionSettings}}"
                haveError="{{.needPassword}}"
                text="{{.connectionParams.pass}}"
                focused="{{passwordTextBoxFocused}}"
                enabled="{{.loginEnabled}}"
                tooltip="{{.tooltipPassword}}"
                placeholder="{{.placeholderPassword}}"
                elementStyle="investing_input_container_login" />
                
            <investingCheckBox styleClassed="savePassClass" text="{{savePassText}}" checked="{{savePasswordChecked}}" visible="{{.selectedConnectionInfoMenuItem.value.allowSavePassword}}"/>

        </div>

        <investingButton name="loginBtn" investingButtonStyle="blue_button_investing button_login" width="200" height="32" enabled="{{.loginEnabled}}" text="{{.loginBtnTxt}}" on-btnClick="@this.startLogin()"/>

        <div class="forgot_password {{^(.forgotPasswordVisible)}}hidden {{/}}" on-click="recoverClick">{{.forgotPasswordLabel}}</div>
        <div class="forgot_password {{^(allowExplore && inputMode)}}hidden {{/}}" on-click="exploreClick" as-tooltip="tooltipExplore">{{.textExplore}}</div>
        <div class="container_logon_state_text">
            <div class="logon_state_text {{#.hasError}}logon_state_text_hasError{{/}}">{{.textErrorLabel}}</div>
        </div>
    </div>

    <investingForgotPasswordScreen allowPreviewPassword="{{.selectedConnectionInfoMenuItem.value.allowPasswordPreview}}" valueLogin="{{.connectionParams.login}}" visible="{{.showForgotScreen}}" />
    <investingChangePasswordScreen name="invChangePassScr" visible="{{.showChangeScreen}}" allowPreviewPassword="{{.selectedConnectionInfoMenuItem.value.allowPasswordPreview}}" />
</div>`;
// Exports
export default code;